import { render, staticRenderFns } from "./BuildingDocumentsTab.vue?vue&type=template&id=57e69022"
import script from "./BuildingDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./BuildingDocumentsTab.vue?vue&type=style&index=0&id=57e69022&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports